import React from "react";
import clsx from "clsx";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { BPEStore } from "../ProductEditorStore";
import ProductChips from "./ProductChips";

const ProductHeader = ({ name }: { name: string }) => {
  const { i18n } = useTranslation();

  const currentRefUnit =
    i18n.language === "de"
      ? BPEStore.data?.reference_unit?.name_de
      : BPEStore.data?.reference_unit?.name;

  const conformities = BPEStore.productSpecifications?.conformities;
  const certifications =
    BPEStore.productSpecifications?.compliant_certifications;
  const healthChecked = BPEStore.productSpecifications?.health_checked_status;

  return (
    <div
      className={clsx(
        "w-full bg-white px-6 py-3 items-center justify-between bg-gradient-to-r from-teal-50",
        "text-lg font-semibold border-b border-gray-200"
      )}
    >
      <div className="h-7">{name || "-"}</div>
      <ProductChips
        refUnit={currentRefUnit}
        conformity={conformities}
        certifications={certifications}
        healthChecked={healthChecked}
        hideIfEmpty
      />
    </div>
  );
};

export default observer(ProductHeader);
